module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"David L. Waldron Architect","short_name":"Waldron Architect","start_url":"/","background_color":"#20232a","theme_color":"#20232a","display":"minimal-ui","icon":"/home/runner/work/velvetfist-davidwaldron/velvetfist-davidwaldron/src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1bca2829baf885eb9f1f3d0cbc1fef90"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
